<div fxLayout="column" class="content" >
    <div class="header" fxLayout="row" fxLayoutAlign="end center">
      <div class="margin">
        <span class="material-icons close-btn pointer" id="dismiss" (click)="dismiss()">
          close
        </span>
      </div>
    </div>

    <div style="height: 100%; padding: 20px 30px 0px 30px;">
        <app-project-create-configuracao [fullWidth]="true" [project]="data.project" [isDuplicar]="data.isDuplicar" (configurationEmitter)="submit($event)"></app-project-create-configuracao>
    </div>

</div>